"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancellationLimitToHours = cancellationLimitToHours;
/**
 * Convert a cancellation-limit Duration to whole hours. Only handles
 * days/hours/minutes since Cortex only ever emits those units for this
 * field; seconds/months/years are intentionally ignored.
 */
function cancellationLimitToHours(d) {
    var _a, _b, _c;
    return ((_a = d.hours) !== null && _a !== void 0 ? _a : 0) + ((_b = d.days) !== null && _b !== void 0 ? _b : 0) * 24 + ((_c = d.minutes) !== null && _c !== void 0 ? _c : 0) / 60;
}
